export default "__VITE_ASSET__CCztd8OK__"